import React from 'react';
import { Alert, Box } from '@mui/material';
import { testHistoryStateStyles } from './styles';

export default function TestHistoryErrorState({ error }) {
  return (
    <Box sx={testHistoryStateStyles.errorContainer}>
      <Alert severity="error">
        <strong>Error loading test results:</strong> {error}
      </Alert>
    </Box>
  );
}
